<template>
  <div v-cloak class="right_col" role="main">
    <el-row class="complain-row" :gutter="20">
      <el-col :span="24">
        <h3>客訴管理</h3>
        <hr />
      </el-col>
    </el-row>
    <el-row class="complain-row" :gutter="20">
      <el-col :span="24">
        <span style="margin-left: 1rem">*註：日期區間為事件發生時間</span>
      </el-col>
    </el-row>
    <el-row class="complain-row" :gutter="20">
      <el-col :span="24">
        <h4 class="col-md-1">起始時間：</h4>
        <DateSelect ref="startTime"></DateSelect>
      </el-col>
    </el-row>
    <el-row class="complain-row" :gutter="20">
      <el-col :span="24">
        <h4 class="col-md-1">結束時間：</h4>
        <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
      </el-col>
    </el-row>
    <hr />

    <!--form-->
    <el-form
      :inline="true"
      :model="searchForm"
      ref="searchForm"
      class="customer-complain-form"
    >
      <el-form-item label="司機:" prop="driverLabel">
        <el-autocomplete
          v-model="searchForm.driverLabel"
          :fetch-suggestions="querySearchAsync"
          placeholder="請輸入司機隊編/呼號"
          @select="onSelectDriver"
          @clear="onClearDriverInput"
          clearable
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="客服種類:" prop="typeId">
        <el-select v-model="searchForm.typeId">
          <el-option
            v-for="type in typeList"
            :key="type.id"
            :label="type.name"
            :value="type.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="立案人員:" prop="managerId">
        <el-select v-model="searchForm.managerId" placeholder="請選擇客服">
          <el-option key="all" label="所有" value="all" />
          <el-option
            v-for="manager in managerList"
            :key="manager.id"
            :label="manager.managerName"
            :value="manager.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="處理進度:" prop="status">
        <el-select v-model="searchForm.status">
          <el-option
            v-for="status in COMPLAIN_STATUS"
            :key="status.key"
            :label="status.label"
            :value="status.value"
          />
        </el-select>
      </el-form-item>
      <!-- button group -->
      <el-form-item>
        <el-button-group>
          <el-button
            type="info"
            @click="onSearch"
            :loading="vx_isSearchBtnLoading"
          >
            搜尋事件
          </el-button>
          <el-button type="danger" @click="resetForm('searchForm')">
            清除搜尋
          </el-button>
          <el-button type="warning" @click="onOpenAddEventDialog">
            編輯客服種類
          </el-button>
          <el-button type="primary" @click="onOpenAddComplainDialog">
            新增客訴單
          </el-button>
          <el-button
            type="success"
            @click="onDownload"
            :loading="isDownloadBtnLoading"
          >
            下載資料
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <!--complain table-->
    <ComplainTable />
    <!--add complain dialog-->
    <AddComplainDialog />
    <!--update complain dialog-->
    <UpdateComplainDialog />
    <!--add event dialog-->
    <AddEventDialog />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { cookies } from '@/utils/cookies'
import { complainStatus } from '@/constants/customerComplain'
import { reqList } from '@/api/driverList'
import { reqType, reqDownload } from '@/api/customerComplain'
import { Notification } from 'element-ui'
import DateSelect from '@/components/tool/DateSelect'
import {
  ComplainTable,
  AddComplainDialog,
  UpdateComplainDialog,
  AddEventDialog,
} from './components'

export default {
  components: {
    DateSelect,
    ComplainTable,
    AddComplainDialog,
    AddEventDialog,
    UpdateComplainDialog,
  },
  data() {
    return {
      driverList: [],
      typeList: [],
      isDownloadBtnLoading: false,
      searchForm: {
        driverLabel: null,
        driverId: null,
        typeId: 'all',
        managerId: 'all',
        status: 'all',
      },
    }
  },
  methods: {
    ...mapMutations('managerStore', {
      vx_setComplainList: 'SET_COMPLAIN_LIST',
      vx_setCurrentPage: 'SET_CURRENT_PAGE',
      vx_setDriverList: 'SET_DRIVER_LIST',
      vx_setTypeList: 'SET_TYPE_LIST',
      vx_setSearchForm: 'SET_SEARCH_FORM',
      vx_setCurrentLoginServiceId: 'SET_CURRENT_LOGIN_SERVICE_ID',
      vx_setIsAddComplainDialog: 'SET_IS_ADD_COMPLAIN_DIALOG',
      vx_setIsAddEventDialog: 'SET_IS_ADD_EVENT_DIALOG',
    }),
    ...mapActions('managerStore', {
      vx_fetchComplainList: 'fetchComplainList',
    }),
    async onSearch() {
      try {
        // 檢查時間是否已設定
        const startTime = this.$refs.startTime.getDate()
        const endTime = this.$refs.endTime.getDate()

        if (!startTime || !endTime) {
          Notification({
            type: 'warning',
            message: '請填寫起始時間和結束時間',
          })
          return
        }

        /* 建構表單 */
        const { driverId, driverLabel, typeId, managerId, status } =
          this.searchForm
        this.vx_setSearchForm({
          teamCode: cookies.get('GladTeamCode'),
          /* 配合server調整為+0時區 */
          start: dayjs(startTime)
            .subtract(8, 'hour')
            .format('YYYY-MM-DD HH:mm:ss'),
          /* 配合server調整為+0時區 */
          end: dayjs(endTime).subtract(8, 'hour').format('YYYY-MM-DD HH:mm:ss'),
          driverId: driverId && driverLabel ? driverId : null,
          typeId: typeId !== 'all' ? typeId : null,
          managerId: managerId !== 'all' ? managerId : null,
          status: status !== 'all' ? status : null,
        })
        this.vx_setCurrentPage(1)
        await this.vx_fetchComplainList()
      } catch (e) {
        Notification({
          type: 'error',
          message: '搜尋事件失敗',
        })
        console.error(e)
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    onOpenAddEventDialog() {
      this.vx_setIsAddEventDialog(true)
    },
    onOpenAddComplainDialog() {
      this.vx_setIsAddComplainDialog(true)
    },
    onClearDriverInput() {
      this.searchForm.driverId = null
      this.searchForm.driverLabel = ''
    },
    async onDownload() {
      if (
        dayjs(this.$refs.startTime.getDate()).isAfter(
          dayjs(this.$refs.endTime.getDate()),
        )
      ) {
        Notification({
          type: 'error',
          message: '起始時間須小於結束時間',
        })
        return
      }
      try {
        this.isDownloadBtnLoading = true
        const { driverId, status, typeId, managerId } = this.searchForm
        const res = await reqDownload({
          /* 配合server調整為+0時區 */
          start: dayjs(this.$refs.startTime.getDate())
            .subtract(8, 'hour')
            .format('YYYY-MM-DD HH:mm:ss'),
          /* 配合server調整為+0時區 */
          end: dayjs(this.$refs.endTime.getDate())
            .subtract(8, 'hour')
            .format('YYYY-MM-DD HH:mm:ss'),
          driver_id: driverId ? driverId : null,
          status: status === 'all' ? null : status,
          type_id: typeId === 'all' ? null : typeId,
          customer_id: managerId === 'all' ? null : managerId,
        })
        if (res) {
          Notification({
            type: 'success',
            message: '請至大量作業進度做下載',
          })
          /* 開啟大量作業進度分頁 */
          const routeUrl = this.$router.resolve({
            path: '/serviceMain/WorkingStatus',
          })
          window.open(routeUrl.href, '_blank')
        } else {
          Notification({
            type: 'error',
            message: '下載失敗',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '下載失敗',
        })
      } finally {
        this.isDownloadBtnLoading = false
      }
    },
    /* 動態搜尋 */
    querySearchAsync(queryString, cb) {
      const filterdResults = queryString
        ? this.driverList.filter(this.driverFilter(queryString))
        : this.driverList
      const results = filterdResults.map((driver) => {
        return {
          value: `${driver.call_number}-${driver.name}`,
          id: String(driver.id),
        }
      })
      cb(results)
    },
    driverFilter(queryString) {
      return (state) =>
        state.call_number.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    },
    /* 司機 */
    async getDriverList() {
      try {
        const { driverList } = await reqList('general', null, null)
        this.vx_setDriverList(driverList)
        this.driverList = driverList
      } catch (e) {
        console.error(e)
      }
    },
    onSelectDriver({ id }) {
      this.searchForm.driverId = id
    },
    /* 客服種類 */
    async getType() {
      this.typeList.push({
        name: '所有',
        id: 'all',
        createdAt: 'all',
      })
      try {
        const { result } = await reqType(cookies.get('GladTeamCode'))
        this.vx_setTypeList(result)
        this.typeList.push(...result)
      } catch (e) {
        console.error(e)
      }
    },
  },
  computed: {
    ...mapGetters({
      managerList: 'managerStore/getManagerList',
    }),
    ...mapState('managerStore', {
      vx_isSearchBtnLoading: 'isSearchBtnLoading',
    }),
  },
  mounted() {
    this.getDriverList()
    this.getType()
    this.onSearch()
  },
  created() {
    this.COMPLAIN_STATUS = complainStatus
  },
}
</script>

<style scoped>
.customer-complain-form {
  margin-left: 1rem;
}

.el-table .warning-row {
  background: oldlace;
}

.complain-row {
  margin-bottom: 20px;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/CustomerComplaint.vue